// extracted by mini-css-extract-plugin
export default {"outsideBox":"steps-progress_outsideBox__gQOpd","insideBox":"steps-progress_insideBox__XOZfA"};